module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Zofingen-6b8ea6be23572918c0d0726a7ab6532b.svg";